import { AchToken } from '../models/ach-token';

export class UpdateAchPaymentModel {
	achToken: AchToken;
	customerId: any = '';
}
